module.exports = function focusTrap(e, setOpen) {
	if (
		e.key === "Tab" ||
		e.key === "ArrowDown" ||
		e.key === "ArrowUp" ||
		e.key === "ArrowLeft" ||
		e.key === "ArrowRight"
	) {
		let direction;
		if (e.key === "Tab") {
			direction = e.shiftKey ? "backward" : "forward";
		} else if (e.key === "ArrowDown" || e.key === "ArrowRight") {
			direction = "forward";
		} else if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
			direction = "backward";
		} else if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			e.target.click();
		}

		if (direction) {
			const focusableElements = e.currentTarget.querySelectorAll(
				'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
			);
			const firstElement = focusableElements[0];
			const lastElement = focusableElements[focusableElements.length - 1];
			if (direction == "backward") {
				if (document.activeElement === firstElement) {
					e.preventDefault();
					lastElement.focus();
				}
			} else {
				if (document.activeElement === lastElement) {
					e.preventDefault();
					firstElement.focus();
				}
			}
		}
	} else if (e.key === "Escape") {
		setOpen(false);
	}
};
